import { useState } from "react"
import * as React from "react"
import { useTranslation } from "react-i18next"
import AppProps from "../../util/AppProps"
import { accountApi } from "../../api/account"
import { Alert, Button, Form, Input } from "antd"
import { FormComponentProps } from "antd/lib/form"
import "./style.css"

const FormItem = Form.Item
interface State {
    error: string | undefined
    success: string | undefined
}
const ForgotPasswordForm = (props: FormComponentProps & AppProps) => {
    const { t } = useTranslation("global")

    const [state, setState] = useState<State>({
        error: undefined,
        success: undefined,
    })

    const onSubmit = (e) => {
        e.preventDefault()
        setState({
            error: "",
            success: "",
        })

        props.form.validateFields((err, values) => {
            if (err) {
                return
            }
            accountApi.forgotPassword(values.email).then(
                () => {
                    setState({
                        success: t(
                            "Email was successfully sent. Please follow the instructions inside in order to reset your password"
                        ),
                        error: undefined,
                    })
                },
                (errorMessage) => {
                    setState({ error: errorMessage.error, success: undefined })
                }
            )
        })
    }

    const { getFieldDecorator } = props.form
    return state.success ? (
        <Alert className="reset-password-success" type="success" message={state.success} />
    ) : (
        <Form onSubmit={onSubmit} className="login-form forgot-form">
            <FormItem>
                {getFieldDecorator("email", {
                    rules: [{ required: true, message: t("Please input your email address") }],
                })(
                    <div className="form-group-input">
                        <Input
                            id="emailInput"
                            className="form-control-input"
                            size="large"
                            type="text"
                            placeholder=" "
                        />
                        <label htmlFor="emailInput" className="form-control-placeholder">
                            {t("Please input your email address")}
                        </label>
                    </div>
                )}
            </FormItem>
            <FormItem>
                <Button onClick={props.history.goBack} type="default" className="forgot-form-button-l">
                    {t("Cancel")}
                </Button>
                <Button type="primary" htmlType="submit" className="forgot-form-button-r">
                    {t("Continue")}
                </Button>
            </FormItem>
            {state.error && (
                <div className="login-form-alert">
                    <img src={"/images/error_alert.png"} alt="" />
                    {state.error}
                </div>
            )}
        </Form>
    )
}

const ForgotPassword = Form.create()(ForgotPasswordForm)

export default ForgotPassword



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/forgotpassword/ForgotPassword.tsx